import React from 'react';
import { Link } from 'react-router-dom';
import { FaExclamationTriangle } from 'react-icons/fa';

export default function NotFound() {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 bg-light">
      <FaExclamationTriangle size={80} className="text-warning mb-4" />
      <h1 className="display-3 fw-bold mb-2 text-danger">404</h1>
      <h2 className="mb-3 text-secondary">Page Not Found</h2>
      <p className="lead mb-4 text-center" style={{maxWidth: 480}}>
        Sorry, the page you are looking for does not exist, was removed, or is temporarily unavailable.
      </p>
      <Link to="/" className="btn btn-primary rounded-pill px-4 py-2 fw-bold">Go to Homepage</Link>
    </div>
  );
} 